export const FETCH_TRABAJADORES_REQUEST = "FETCH_TRABAJADORES_REQUEST";
export const FETCH_TRABAJADORES_SUCCESS = "FETCH_TRABAJADORES_SUCCESS";
export const FETCH_TRABAJADORES_FAILURE = "FETCH_TRABAJADORES_FAILURE";

export const FETCH_TRABAJADOR_ONE_SUCCESS = "FETCH_TRABAJADOR_ONE_SUCCESS";
export const FETCH_TRABAJADOR_ONE_FAILURE = "FETCH_TRABAJADOR_ONE_FAILURE";

export const FETCH_PUESTOS_SUCCESS = "FETCH_PUESTOS_SUCCESS";
